import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

export const PriceChip = ({ children, size = 'small' }: { children: ReactNode; size?: 'small' | 'large' }) => {
  return (
    <Box
      borderRadius="8px"
      sx={{
        backgroundColor: '#F7F5FF',
        px: size === 'small' ? 1 : 2,
        py: size === 'small' ? 0.5 : 1,
        textAlign: 'center',
      }}
    >
      <Typography
        variant={size === 'small' ? 'body1' : 'h5'}
        fontWeight="bold"
        sx={{
          margin: '0 auto',
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};
